module.exports = __webpack_public_path__ + "static/media/Manual_Portal_Atualizado.d13e0adc.pdf";